import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { dms } from "@/pages/dms/api";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  const close = (v) => {
    if (!v) { setOldPw(""); setNewPw(""); setConfirm(""); setMsg(null); }
    onOpenChange(v);
  };

  const submit = async () => {
    setMsg(null);
    if (newPw !== confirm) { setMsg({ ok: false, text: "New password and confirm do not match" }); return; }
    setBusy(true);
    try {
      await dms.changePassword(oldPw, newPw);
      setMsg({ ok: true, text: "Password changed. Use the new password next time you sign in." });
      setOldPw(""); setNewPw(""); setConfirm("");
    } catch (e) {
      const d = e?.response?.data?.detail;
      setMsg({ ok: false, text: typeof d === "string" ? d : "Could not change password" });
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent>
        <DialogHeader><DialogTitle>Change Password</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <Input type="password" placeholder="Current password" value={oldPw} onChange={e => setOldPw(e.target.value)} autoComplete="current-password" />
          <Input type="password" placeholder="New password (8+ chars, 1 capital, 1 digit)" value={newPw} onChange={e => setNewPw(e.target.value)} autoComplete="new-password" />
          <Input type="password" placeholder="Confirm new password" value={confirm} onChange={e => setConfirm(e.target.value)} autoComplete="new-password" />
          {msg && <div className={"text-sm " + (msg.ok ? "text-emerald-600" : "text-rose-600")}>{msg.text}</div>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => close(false)}>Close</Button>
          <Button onClick={submit} disabled={busy || !oldPw || !newPw || !confirm}>{busy ? "Saving..." : "Change Password"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
